import { useMutation } from '@tanstack/react-query';

import { publishEvent as publishEventApi } from '../services/promoterEndpoint.ts';

export const usePublishEventsMutation = () => {
  return useMutation({
    mutationFn: async ({ incompleteEventId }: { incompleteEventId: string }) => {
      const result = await publishEventApi(incompleteEventId);

      if ('type' in result) {
        throw new Error(result.message);
      }

      return result;
    },
  });
};
